import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import SpeczeLogo from '../../assets/SpeczeLogo'
import toast from 'react-hot-toast'

const navItems = [
  { to: '/dashboard',                end: true, icon: '⊞', label: 'Dashboard' },
  { to: '/dashboard/projects',               icon: '⬡', label: 'Projects' },
  { to: '/dashboard/documents',              icon: '◻', label: 'Documents' },
  { to: '/dashboard/specifications',         icon: '◈', label: 'Specifications' },
  { to: '/dashboard/test-plans',             icon: '✓', label: 'Test Plans' },
  { to: '/dashboard/settings',               icon: '⚙', label: 'Settings' },
]

export default function DashboardLayout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    toast.success('Signed out successfully.')
    navigate('/login')
  }

  return (
    <div className="flex h-full overflow-hidden bg-cosmic-950">
      {/* Sidebar */}
      <aside className="w-60 flex-shrink-0 flex flex-col bg-cosmic-900 border-r border-white/6">
        {/* Logo */}
        <div className="px-5 py-5 border-b border-white/6">
          <SpeczeLogo size={30} />
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
          {navItems.map(({ to, end, icon, label }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="text-base w-5 text-center">{icon}</span>
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        {/* User */}
        <div className="p-3 border-t border-white/6">
          <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl bg-white/3">
            <img src={user?.avatar_url} alt={user?.name}
              className="w-8 h-8 rounded-full ring-1 ring-purple-500/30 flex-shrink-0"
              onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || 'U')}&background=7C3AED&color=fff` }}
            />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-white truncate">{user?.name}</p>
              <p className="text-[10px] text-white/30 truncate capitalize">{user?.plan} plan</p>
            </div>
            <button onClick={handleLogout} title="Sign out"
              className="text-white/25 hover:text-red-400 transition-colors flex-shrink-0">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
              </svg>
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
